export default __webpack_public_path__ + "static/Team-Picker-Wheel-b844c11c0ff8f03e689d02bebe1eb210.png";